module.exports = __webpack_public_path__ + "img/cat.41a0615d.png";